module.exports = __webpack_public_path__ + "img/circle-shape.c287c2d1.png";